import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SmsService } from 'src/app/pages/get-started/sms.service';
import { AlertService } from 'src/app/services/alert.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'df-download-options',
  templateUrl: './download-options.component.html',
  styleUrls: ['./download-options.component.scss']
})
export class DownloadOptionsComponent {
  @Input() showStoreLinks: any;
  @Input() slideConfig: any; // Current slide configuration
  @Output() closeModal = new EventEmitter<void>();
  phoneForm: FormGroup<{ phone: FormControl<any>; }>;
  isSent: boolean = false;
  isDisabled: boolean = true;
  facilityConfig: FacilityConfig;
  appStoreUrl: string = '';
  playStoreUrl: string = '';

  constructor(
      private sms: SmsService
    , private alertService: AlertService
    , private _environmentService: EnvironmentService
    , private router: Router
  ) {
    this.phoneForm = new FormGroup({
      phone: new FormControl()
    });
    this.facilityConfig = this._environmentService.getFacilityConfig();
  }

  onPhoneEnter(e: any) {
    let phone = this.phoneForm?.get('phone')?.value;
    if (!phone || phone.length < 14) {
      this.isDisabled = true;
      this.isSent = false;
      return;
    }
    this.isDisabled = false;
    if (e.code === 'Enter') {
      this.isSent = true;
      this.sms.sendPhoneLinkSms(phone)?.pipe().subscribe(() => {
        this.alertService.info('A link to download the app has been sent.', true, true);
      });
    }
  }

  inputChanged(evt: any) {
    // if auto-fill happened and value didn't get entered
    window.setTimeout(() => {
      if (this.phoneForm?.get('phone') && this.phoneForm.get('phone')?.value !== evt.target.value) {
        this.phoneForm.get('phone')?.setValue(evt.target.value);
        this.isDisabled = false;
      }
    }, 100);
  }

  onButtonClick() {
    // Close the modal first
    this.closeModal.emit();
    
    // Then navigate to the specified URL
    if (this.slideConfig?.buttonUrl) {
      this.router.navigate([this.slideConfig.buttonUrl]);
    }
  }
}
